// lib/types.ts
export type ProblemDetails = {
    type?: string;
    title?: string;
    status?: number;
    detail?: string | null;
    instance?: string;
    // Optional DB diagnostics we attach server-side
    sql?: string;
    sqlState?: string;
    vendorCode?: number;
    position?: number;
    where?: string;
    internalQuery?: string;
    schema?: string;
    routine?: string;
    constraint?: string | null;
    table?: string | null;
    column?: string | null;
    errors?: unknown; // some endpoints may also include `errors`
    /** PCF validation endpoints add a violations array (one string per failed validator). */
    violations?: string[];
};

export function isProblemDetails(x: unknown): x is ProblemDetails {
    return !!x && typeof x === 'object' && ('title' in x || 'status' in x || 'type' in x);
}

export type Failure = {
    phase: string;
    description: string;
    sql?: string | null;
    sqlState?: string | null;
    vendorCode?: number | null;
    constraint?: string | null;
    table?: string | null;
    column?: string | null;
    detail?: string | null;
    hint?: string | null;
    errorClass?: string | null;
    message?: string | null;
    position?: number | null;
    where?: string | null;
    internalQuery?: string | null;
    schema?: string | null;
    routine?: string | null;
};

// --- OpenAPI Spec Import ---

export interface ImportedSpec {
  id: string;
  name: string;
  specVersion: string | null;
  specTitle: string | null;
  endpointCount: number;
  createdAt: string;
}

export interface EndpointParameter {
  name: string;
  in: string; // path, query, header
  required: boolean;
  type: string;
  description: string | null;
}

export interface ParsedEndpoint {
  operationId: string;
  method: string; // GET, POST, PUT, PATCH, DELETE
  path: string;
  summary: string | null;
  description: string | null;
  parameters: EndpointParameter[];
  requestBodySchema: Record<string, unknown> | null;
  tags: string[];
}

export type ActivationResponse = {
    projectId: string;
    pcfId: string;
    success: boolean;
    message?: string;
    executedCount?: number;
    errors?: Failure[];
};
